<template>
  <div class="stage-stepper">
    <div v-for="step in dynamicSteps" :key="step.key" class="step">
      <div
        class="bar"
        :class="[isStageActive(step.key) ? 'bg-primary' : 'bg-neutral-40']"
      ></div>
      <div class="title" :class="step.titleColor" v-html="step.title"></div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  stages: {
    type: Array,
    default: () => [],
  },
});

const activeStageSet = computed(() => {
  return new Set(props.stages);
});

const getPodStatus = () => {
  if (activeStageSet.value.has("pod_rejected"))
    return "<span class='text-error-80'>POD Rejected</span>";

  if (activeStageSet.value.has("pod_accepted")) return "POD Accepted";

  return "<span class='text-success-60'>POD Accepted</span> <span class='text-neutral-80'>/</span> <span class='text-error-80'>Rejected</span>";
};

const getQcStatus = () => {
  if (activeStageSet.value.has("qc_rejected"))
    return "<span class='text-error-80'>QC Rejected</span>";

  if (activeStageSet.value.has("qc_accepted")) return "QC Accepted";

  return "<span class='text-success-60'>QC Accepted</span> <span class='text-neutral-80'>/</span> <span class='text-error-80'>Rejected</span>";
};

const baseSteps = [
  { key: "not_started", titleColor: "text-neutral-70" },
  { key: "pod_pending", titleColor: "text-warning-70" },
  { key: "pod_received", titleColor: "text-info-70" },
  { key: "pod_accepted", titleColor: "text-success-70" },
  { key: "qc_received", titleColor: "text-warning-50" },
  { key: "qc_accepted", titleColor: "text-success-70" },
  { key: "completed", titleColor: "text-success-80" },
];

const dynamicSteps = computed(() => {
  const labels = {
    not_started: "Not Started",
    pod_pending: "POD Pending",
    pod_received: "POD Received",
    pod_accepted: getPodStatus,
    qc_received: "QC Received",
    qc_accepted: getQcStatus,
    completed: "Completed",
  };

  return baseSteps.map((step) => ({
    ...step,
    title:
      typeof labels[step.key] === "function"
        ? labels[step.key]()
        : labels[step.key] || "",
  }));
});

const isStageActive = (key) => {
  if (key === "pod_accepted")
    return (
      activeStageSet.value.has("pod_accepted") ||
      activeStageSet.value.has("pod_rejected")
    );

  if (key === "qc_accepted")
    return (
      activeStageSet.value.has("qc_accepted") ||
      activeStageSet.value.has("qc_rejected")
    );

  return activeStageSet.value.has(key);
};
</script>

<style scoped lang="scss">
.stage-stepper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  .step {
    width: 100%;
    margin: 0 4px;
  }

  .bar {
    height: 6px;
    border-radius: 8px;
  }

  .title {
    font-size: 12px;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
